import { createContext, useContext } from "react";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function createGlobalContext<T>(defaultValue?: T) {
  const GlobalContext = createContext<T>(defaultValue as unknown as T);
  const { Consumer: GlobalContextConsumer, Provider: GlobalContextProvider } =
    GlobalContext;

  const hookCreator = <R>(map: (gc: T) => R) => (): R => {
    const global = useContext(GlobalContext);
    if (!global) {
      throw new TypeError(
        "Global context do not exist. Did you forget to add a value?",
      );
    }
    return map(global);
  };

  return {
    GlobalContext,
    GlobalContextConsumer,
    GlobalContextProvider,
    hookCreator,
  };
}
